import { render, staticRenderFns } from "./SingleTestDataInfo.vue?vue&type=template&id=46a7aba4"
import script from "./SingleTestDataInfo.vue?vue&type=script&lang=js"
export * from "./SingleTestDataInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports